if(!customElements.get('wlsn-cart-drawer')) {
  class WLSNCartDrawer extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        toggleElement: 'js-wlsn-cart-drawer-toggle',
        loading: 'wlsn-cart-drawer-loading',
      };

      this.bindMethods = {
        toggleCartDrawer: this.toggleCartDrawer.bind(this),
        handleToggleClick: this._handleToggleClick.bind(this),
        handleEscKey: this._handleEscKey.bind(this),
        handleDrawerOpen: this._handleDrawerOpen.bind(this),
        handleUpdateStart: this._handleUpdateStart.bind(this),
        handleUpdateSuccess: this._handleUpdateSuccess.bind(this),
        handleUpdateError: this._handleUpdateError.bind(this),
      };
    }

    get elements() {
      return {
        toggleElements: this.querySelectorAll(`.${this.classes.toggleElement}`),
      }
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    disconnectedCallback() {
      this._detachEventListeners();
    }

    _attachEventListeners() {
      this.addEventListener('click', this.bindMethods.handleToggleClick);
      document.addEventListener('keydown', this.bindMethods.handleEscKey);
      document.addEventListener('wlsn:cart:drawer:open', this.bindMethods.handleDrawerOpen);
      document.addEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.addEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.addEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    _detachEventListeners() {
      this.removeEventListener('click', this.bindMethods.handleToggleClick);
      document.removeEventListener('keydown', this.bindMethods.handleEscKey);
      document.removeEventListener('wlsn:cart:drawer:open', this.bindMethods.handleDrawerOpen);
      document.removeEventListener('wlsn:cart:update:start', this.bindMethods.handleUpdateStart);
      document.removeEventListener('wlsn:cart:update:success', this.bindMethods.handleUpdateSuccess);
      document.removeEventListener('wlsn:cart:update:error', this.bindMethods.handleUpdateError);
    }

    /**
     * Handle update start event.
     * @returns {void}
     */
    _handleUpdateStart() {
      this._setLoadingState(true);
    }

    /**
     * Handle update success event.
     * @returns {void}
     */
    _handleUpdateSuccess() {
      this._setLoadingState(false);
    }

    /**
     * Handle update error event.
     * @returns {void}
     */
    _handleUpdateError() {
      this._setLoadingState(false);
    }
    
    /**
     * Set loading state
     * @param {boolean} loading - Whether to show loading state
     * @returns {void}
     */
    _setLoadingState(loading) {
      this.classList.toggle(this.classes.loading, loading);
    }

    /**
     * Handle drawer open event.
     * @returns {void}
     */
    _handleDrawerOpen() {
      this.classList.add(this.classes.active);
    }

    /**
     * Handle click on toggle (close button or overlay). Uses delegation so it works
     * after drawer content is replaced (e.g. after add-to-cart).
     * @param {MouseEvent} event - Click event
     * @returns {void}
     */
    _handleToggleClick(event) {
      if (event.target.closest(`.${this.classes.toggleElement}`)) {
        this.toggleCartDrawer();
      }
    }

    /**
     * Handle the ESC key.
     * @param {KeyboardEvent} event - The keyboard event.
     * @returns {void}
     */
    _handleEscKey(event) {
      if (event.key === 'Escape') {
        this.toggleCartDrawer();
      }
    }

    /**
     * Toggle the cart drawer open/closed.
     * @returns {void}
     */
    toggleCartDrawer() {
      const isOpen = this.classList.contains(this.classes.active);
      this.classList.toggle(this.classes.active, !isOpen);
    }
  }
  customElements.define('wlsn-cart-drawer', WLSNCartDrawer);
}